import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  remoteControl: number | 'no',
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (remoteControl, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      remoteControl,
    },
  });
};

export const RemoteControl = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    remoteControl: remoteControlAddonProducts,
    custom: { remoteControl },
  } = state.context;

  if (
    isCurrentState('remoteControl', state) &&
    remoteControlAddonProducts.length === 0
  ) {
    throwError(state, `window.remoteControl is empty`);
  }

  return (
    <SectionContent>
      <Heading>Remote control</Heading>
      <Selector>
        {remoteControlAddonProducts.map(product => {
          const {
            title,
            first_available_variant: { id },
          } = product;
          return (
            <SelectorItem
              key={id}
              isSelected={remoteControl === id}
              onClick={onClick(id, send)}
            >
              {title}
            </SelectorItem>
          );
        })}

        <SelectorItem
          key="no"
          isSelected={remoteControl === 'no'}
          onClick={onClick('no', send)}
        >
          No, thanks
        </SelectorItem>
      </Selector>
    </SectionContent>
  );
};
